import React from 'react'
import styled from '@emotion/styled'
import { Key } from 'stylist'
import QRCode from 'react-qr-code'
import TwoFactorForm from './TwoFactorForm'

const TwoFAContainer = styled.div`
  width: 100% !important;
`

const TwoFAInstructionsContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  @media only screen and (max-width: 1000px) {
    flex-direction: column;
  }
`

const TwoFAInstructions = styled.div`
  width: 50%;
  @media only screen and (max-width: 1000px) {
    width: 100%;
  }
`

const TwoFACodes = styled.div`
  width: 40%;
  @media only screen and (max-width: 1000px) {
    width: 100%;
    margin-bottom: 20px;
  }
`

const BoldText = styled.p`
  font-weight: bold;
`

const Text = styled.div`
  margin-bottom: 20px;
`

const Paragraph = styled.p`
  margin-bottom: 12px;
`

const StyledFormContainer = styled.div`
  width: 50%;
  @media only screen and (max-width: 1000px) {
    width: 100%;
  }
`

const StyledQRCode = styled.div`
  text-align: center;
`

const CodeContainer = styled.div`
  padding: 12px;
  background: #f0eceb;
  display: flex;
  width: 75%;
  justify-content: space-between;
  margin: auto;

  @media only screen and (max-width: 1000px) {
    width: 50%;
  }
`

const StyledIcon = styled(Key)`
  width: 20%;
  @media only screen and (max-width: 1000px) {
    width: 12%;
  }
`

const Code = styled.div`
  width: 70%;
  word-wrap: break-word;
  text-align: justify;
  @media only screen and (max-width: 1000px) {
    width: 80%;
  }
`

const TwoFactorSetup = ({ uri2FA, code, notify, authenticate, product }) => {
  const switchToNewName = () => {
    if (product.toLowerCase() === 'revelation') {
      return 'Digital Diaries'
    } else if (product.toLowerCase() === 'kinesis') {
      return 'Panel Management'
    } else if (product.toLowerCase() === 'vi') {
      return 'VideoInsights'
    }
    return product
  }

  return (
    <TwoFAContainer>
      <p>
        Sign into {switchToNewName()} requires two-factor authentication (2FA)
        for enhanced security.
      </p>
      <TwoFAInstructionsContainer>
        <TwoFAInstructions>
          <BoldText>Step 1. Configure your 2FA app</BoldText>
          <Text>
            <Paragraph>
              To configure 2FA, you'll need to have a Google Authenticator app
              installed on your phone or tablet.
            </Paragraph>

            <Paragraph>
              Once you've installed it, open the app and scan the QR code or
              manually enter the key on the right.
            </Paragraph>
          </Text>
          <BoldText>Step 2. Enter a 2FA code</BoldText>
          <Text>
            <Paragraph>
              Generate a code from your newly-activated Google Authenticator app
              to confirm that the account was properly set up and enter it in
              the field below.
            </Paragraph>
          </Text>
        </TwoFAInstructions>
        <TwoFACodes>
          <StyledQRCode>
            <QRCode size={200} value={uri2FA} />
            <CodeContainer>
              <StyledIcon size="sm" />
              <Code>{code}</Code>
            </CodeContainer>
          </StyledQRCode>
        </TwoFACodes>
      </TwoFAInstructionsContainer>
      <StyledFormContainer>
        <TwoFactorForm notify={notify} authenticate={authenticate} />
      </StyledFormContainer>
    </TwoFAContainer>
  )
}

export default TwoFactorSetup



// WEBPACK FOOTER //
// ./src/routes/login/components/TwoFactorSetup.js